import './footer.css'


const Footer = ({pageNo}) => {

    return (
        <footer>
            <div className='divider-line-footer' />
            <div className='footer'>
                <div className='footer-left'>
                    <img src='../images/Logos/pvxLogo.svg' alt='logo' />
                    <div className='vertical-line' />
                    <p>Smith PVX Solar Design Tool</p>
                </div>
                <div className='footer-right'>
                    {pageNo}
                </div>
            </div>
        </footer>
    );
}

export default Footer;